
















import { Vue, Component, Prop } from "vue-property-decorator";
import ModalBase from "@/components/ModalBase.vue";
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";

const QrCodeDeepLinkModalProps = Vue.extend({
  computed: {
    ...mapState("vas", ["saleType", "merchantDetails", "merchantShopDetails"]),
    ...mapState("global", ["cart", "checkout"]),
    ...mapGetters("vas", [
      "merchant",
      "isEnabled",
      "hasNoDeliverySlots",
      "hasDelivery",
      "requiresDeliverySlots",
      "hasAvailableSlots",
      "hasScheduledPickupAvailable",
      "availableSaleTypes",
    ]),
  },
  methods: {
    ...mapActions("vas", ["fetchMerchant"]),
  },
});

@Component({
    components: {
        ModalBase,
        VueQrcode
    },
})
export default class QrCodeDeepLinkModal extends QrCodeDeepLinkModalProps {
    handleCancel() {
        this.$emit("cancel");
    }
}
